import { Base } from '@studiometa/js-toolkit';

/**
 * Mascotte component
 */
export default class Mascotte extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Mascotte',
    refs: ['text'],
  };

  /**
   * Mounted
   */
  mounted() {
    console.log('niuted');

    this.initObserver();
  }

  /**
   * Init IntersectionObserver
   */
  initObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.$el.classList.remove('opacity-0', 'translate-y-5');
            setTimeout(() => {
              if (this.$refs.text) {
                this.$refs.text.classList.remove('opacity-0', 'scale-50');
              }
            }, 1000);

            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 1,
      },
    );

    observer.observe(this.$el);
  }
}
